import { enqueueSnackbar } from "notistack"

const handleCopiarTexto = (text: string) => {
    navigator.clipboard.writeText(text)
      .then(() => enqueueSnackbar("Texto copiado para a área de transferencia!", { variant: "success" }))
      .catch(() => enqueueSnackbar('Falha ao copiar o texto', { variant: "error" }))
  }

export default handleCopiarTexto